export const TEXTS = {
    ADD_A_NEW_CARD: "Add a New Card",
    ADD_A_NEW_FOOD_CARD: "Add a New Food Card",
    ADD_MONEY: "ADD MONEY",
    ALL_BANKS: "All Banks",
    APPLY: "apply",
    ARE_YOU_SURE_WANT_TO_REFRESH: "Are you sure want to refresh?",
    CANCEL: "Cancel",
    CANCEL_PAYMENT: "Cancel Payment",
    CARD_NUMBER: "Card Number",
    CARD_VALIDITY: "CARD VALIDITY",
    COD: "COD",
    CASH: "Cash",
    CRED: "CRED",
    PAYTM: "Paytm",
    CONFIRM: "Yes, delink account",
    PAY_USING_CRED: "Pay via CRED",
    CONFIRM_TO_PLACE_ORDER: "Confirm to place order",
    CONTINUE_WITHOUT_DISCOUNT: "Continue Without Discount",
    COUPON_CODE_X: "Coupon Code: {0}",
    COUPON_NOT_APPLICABLE: "Coupon Not Applicable",
    COUPON_NOT_APPLICABLE_FOR_THIS_PAYMENT_METHOD: "Coupon is not applicable for this payment method",
    COUPON_X_NOT_APPLICABLE: "Coupon code {0} is not applicable for these options",
    CVV: "CVV",
    DECLINED: "DECLINED",
    DID_NOT_RECIEVE_OTP: "Didn’t get OTP?",
    DISMISS: "DISMISS",
    ENTER_OTP: "ENTER OTP",
    ENTER_OTP_RECEIVED_ON_X: "Enter OTP received on {0}",
    ENTER_OTP_RECEIVED: "Enter OTP received on",
    ENTER_YOUR_CARD_DETAILS: "Enter your card details",
    ENTER_YOUR_FOOD_CARD_DETAILS: "Enter your food card details",
    FOOD: "FOOD",
    INVALID_CARD_NUMBER: "Invalid Card Number",
    INVALID_CVV: "Invalid CVV",
    INVALID_EXPIRY_DATE: "Invalid Expiry Date",
    INVALID_CARD_NAME: "Name should not be blank",
    ITEM: "Item",
    ITEMS: "Items",
    LINK_ACCOUNT: "Link Account",
    LOADING: "Loading...",
    LINK_X_ACCOUNT: "Link {0} Account",
    LINK_X_WALLET: "Link {0} wallet",
    LINK_YOUR_X_WALLET: "Link your {0} wallet",
    LOW_BALANCE_DETAIL: "Low balance. You need \u20B9{0} more in your account",
    INSUFFICIENT_BALANCE_DETAIL: "Insufficient balance. You need \u20B9{0} more in your account",
    LINK_MOBILE_NUMBER_TITLE: "Enter mobile number to link {0} account",
    LINK_MOBILE_NUMBER_SUBTITLE: "If you don’t have an account, we will create one for you",
    LOW_BALANCE_BRIEF: "Low balance",
    MONTH_FORMAT: "MM",
    MORE_BANKS: "More Banks",
    INDIAN_MOBILE_CODE: "+91",
    NAME_ON_THE_CARD: "Name on Card",
    NETBANKING: "NetBanking",
    NETBANKING_CARDS_WALLETS: "Netbanking, Credit/Debit Cards, Wallets",
    NEXT: "Next",
    OFFER: "OFFER",
    OTHER_PAYMENT_METHODS: "Other Payment Methods",
    PAY: "Pay",
    IN_SINGLE_CLICK: " in Single Click",
    PAY_USING_OTHER_MODES: "Pay using other modes",
    PAY_USING_X: "Pay Using {0}",
    PAY_WITH_CASH: "Pay with Cash",
    PAY_X_WITH_CASH: "Pay ₹{0} with Cash",
    PAY_X: "Pay ₹{0}",
    AVAILABLE_CREDIT_X: "Available credit: \u20B9{0}",
    KEY_FACTS_DISCLAIMER_TURBO: "I understand and agree to the ",
    KEY_FACTS_DISCLAIMER: "By Proceeding, I understand and agree to the ",
    KEY_FACTS_STATEMENT: "Key Fact Statement",
    SETUP_PIN_AND_PAY_X: "Setup PIN & Pay ₹{0}",
    PAY_AMOUNT_X_ITEM: "₹{0}  |  {1} Item",
    PAY_AMOUNT_X_ITEMS: "₹{0}  |  {1} Items",
    ENABLE_AND_PROCEED: "Enable & Proceed",
    PAY_WITHOUT_CLICK: "I’ll pay in multiple steps",
    PROCEED_TO_PAY: "Proceed To Pay",
    PROCEED_TO_PAY_AMOUNT: "Proceed To Pay ₹{0}",
    WARNING_INFO_ADD_CARD: "Your card is not eligible for this offer. Your bill amount is updated to ₹{0}.",
    PROCEED: "Proceed",
    PROCEED_WITHOUT_OFFER: "Proceed without offer",
    PAYMENT_FAILURE: "Payment Failure",
    PAYMENT_FAILURE_MESSAGE:
        "Seems like there was some error in processing your transaction. The payment failed to pass through.",
    PAYMENT_OPTIONS: "Payment Options",
    PLACE_ORDER: "Place Order",
    POPULAR_BANKS: "Popular Banks",
    PREFERRED_PAYMENT_MODE: "Preferred payment mode for this offer",
    PROCEED_LINK: "Proceed to link with this number",
    PROCEED_TO_LINK_WITH_X: "Proceed to link {0} with email id and number:",
    RE_X_WILL_BE_CHARGED: "Re. {0} will be charged",
    RESEND_CODE: "RESEND CODE",
    RESEND: "RESEND",
    RESENDING_CODE: "Resending ...",
    RETRY: "RETRY",
    SAVE: "Save",
    SAVED_CARDS: "Saved Cards",
    SECURE_YOUR_CARD_WITH_VISA: "Secure your card. ",
    SECURE_YOUR_CARD_WITH_VISA_WITH_BRAND: "Secure your card with {0}. ",
    SECURE_SAVE_YOUR_CARD: "Securely save your card",
    SECURELY_SAVE_CARD_DETAILS: "Securely save card details",
    SELECT_BANK: "Select Bank",
    SIMPL: "Simpl",
    SIMPL_DELINK_SUCCESS_TITLE: "Simpl has been delinked successfully!",
    SIMPL_DELINK_FAILURE_TITLE: "We couldn’t delink your Simpl account",
    SOMETHING_WENT_WRONG: "Oops!! Something went wrong",
    SUPER_CONFIRM_TITLE: "{0} ahead.",
    TAP_TO_RELOAD: "TAP TO RELOAD",
    TERMS_AND_CONDITIONS: "Terms & Conditions",
    TIMED_OUT: "TIMED_OUT",
    TO_PAY_X: "To pay: \u20B9{0}",
    TO_PAY_X_NO_COLON: "To pay \u20B9{0}",
    TOKEN_EXPIRED_LINK_ACCOUNT: "Token is expired. Please relink again",
    TRY_AGAIN: "Try Again",
    TRY_OTHERS: "Try Others",
    VALID_THROUGH: "Valid Through",
    VERIFY_N_PROCEED: "VERIFY AND PROCEED",
    VERIFY_N_LINK: "Verify and Link Account",
    WALLET_LINK_NOTE: "Don’t have {0} wallet? We will create one for you.",
    WALLET_REDIRECT_NOTE: "You will be redirected to {0}",
    WALLETS: "Wallets",
    X_ITEM_TO_PAY_Y: "{0} Item, To pay: \u20B9{1}",
    X_ITEMS_TO_PAY_Y: "{0} Items, To pay: \u20B9{1}",
    YEAR_FORMAT: "YY",
    YOU_HAVE_ENOUGH_MONEY: "You have enough Swiggy Money to place an order",
    PAY_X_WITH_Y: "Pay \u20B9{0} with {1}",
    OFFER_APPLIED: "Offer applied",
    PAY_USING_OTHER: "Pay using other methods",
    COUPON_X_NOT_APPLICABLE_ON_OTHER_METHODS: "Coupon {0} won't be applicable on other methods",
    X_REWARD_WONT_BE_APPLICABLE_ON_OTHER_METHODS: "{0} reward won't be applicable on other methods",
    REMAINING_AMOUNT: "Select any payment method below to pay the remaining \u20B9{0}",
    KNOW_MORE: "Know more",
    CARD_NICKNAME: "Card Nickname (for easy identification)",
    INVALID_NICKNAME: "Nick name should not be blank",
    REMOVE_CARD_JUNE_END: "Remove this card on 30th Sept",
    SECURE_CARD_AND_PAY: "Secure card & pay",
    GOT_IT: "Got it",
    CARD_NETWORK: "card network",
    VERIFY_CVV_MESSAGE:
        "You need to do a \u20B92 payment to proceed. This will be refunded after securing your card with {0}’s vault",
    VERIFY_CVV_MESSAGE_SAVE_CARD:
        "You need to do a \u20B92 payment to verify the card. This will be refunded after the card verification.",
    PAY_X_AND_SECURE: "Pay \u20B9{0} & Secure",
    PAY_X_AND_ADD: "Pay \u20B9{0} & Add",
    STORE_YOUR_CARD: "Store Your Card with {0}",
    MANAGE_CARD_SAVE_BUTTON: "Save Changes",
    MANAGE_CARD_SAVE_AND_SECURE_BUTTON: "Save Changes & secure Card",
    CARD_BRAND: "{{cardBrand}}",
    CURRENT_BALANCE: "Current balance",
    ENTER_AMOUNT: "Enter Amount",
    RUPEE: "₹",
    DELINK: "Delink",
    DELINK_METHOD_ACCOUNT: "Delink {0} Account",
    DELINK_CONFIRMATION_TITLE: "Are you sure you want to delink wallet?",
    DELINK_CONFIRMATION_METHOD_ACCOUNT_TITLE: "Are you sure you want to delink {0} account?",
    DELINK_CONFIRMATION_METHOD_ACCOUNT_SUBTITLE: "This will affect all payment methods related to {0}",
    DELINK_FAILURE_TITLE: "We couldn’t delink your {0} account linked to {1}",
    DELINK_SUCCESS_ACCOUNT_TITLE: "{0} account methods linked to {1} is successfully delinked",
    DELINK_SUCCESS_TITLE: "{0} wallet linked to {1} is successfully delinked",
    DELINK_SUCCESS_SUBTEXT: "You can now link with a different number",
    AMAZON_PAY_DELINK_SUCCESS_TITLE: "Your Amazon account has been delinked succesfully",
    AMAZON_PAY_DELINK_FAILURE_TITLE: "We couldn’t delink your Amazon account",
    SELECT_ANOTHER_CARD: "Select another card",
    SECURE_CARD: "Secure this card.",
    WHY_IS_IT_IMP: "Why is it important?",
    NO_CVV_OTP: "No CVV/OTP needed for most payments.",
    SAVE_CARD_AND_PAY: "Save card & Pay",
    SAVE_CARD_AND_PROCEED: "Save card & Proceed",
    PAY_WITHOUT_SAVING: "Pay without saving",
    AMOUNT_WITH_RUPEE_SYMBOL: "₹{0}",
    CHANGE: "Change",
    VIA: "via",
    SWIGGY_PAY_CALLOUT: "Paying ₹{0} with swiggy money from your total bill value of ₹{1}",
    // $amount placeholder is configured on backend
    AMOUNT: "$amount",
    PAYMENT_METHOD_DISABLED_WALLET: {
        PAYTM: "To activate Paytm wallet, sign up on the Paytm App",
        DEFAULT: "This payment method is disabled",
    },
    NEW: "NEW",
    VIEW_ALL_REWARDS: "View all rewards",
    YOUR_AVAILABLE_REWARDS: "Your available rewards",
    VIEW_UNAVAILABLE_REWARDS: "View unavailable rewards",
};

export const ACCESSIBILITY_ROLES = {
    DIALOG: "dialog",
    ALERTDIALOG: "alertdialog",
    HEADING: "heading",
    BUTTON: "button",
    CHECKBOX: "checkbox",
    ALERT: "alert",
    GENERIC: "generic",
};

export const ASCII_CODES = {
    ENTER: 13,
};

export const KEYBOARD_KEYS = {
    ENTER: "Enter",
};

export const WE_ACCEPT_LOGOS_SET = {
    ALL: "ALL",
    FOOD: "FOOD",
    NON_FOOD: "NON_FOOD",
};

export const ACCESSIBILITY_TEXTS = {
    NOT_LINKED: "Not linked.",
    REMAINING_BALANCE: "Remaining balance: \u20B9{0}.",
    SELECTED: "Selected",
};

export const OTHER_PAYMENTS_ICON = "PaymentLogos/paymentIcons/otherMethods";
export const PLACE_ORDER_EXTRA_PARAMS = {
    SWIGGY_PAY_AMOUNT: "swiggy_pay_amount",
};

export const TWID_PAY_ICON = "portal/m/twid_logo.png";

export const BASE_64_IMAGE_PREFIX = "data:image/png;base64,";

export const BLACK_MEMBERSHIP_BENEFIT_BORDER = "portal/testing/one-black-test/star_with_border_bottom.png";
export const BR_TAG = "<br/>";

export const BILL_IMAGE_REQUIRED = {
    HEADING: "Bill Image Required",
    DESCRIPTION:
        "A clear, legible bill image is mandatory. Swiggy isn't liable for rejections due to unclear or incomplete uploads.",
    PROCEED_BTN: "Proceed to bill upload",
    NO_THANKS_BTN: "No thanks",
    HALF_CARD_ASSET: "portal/static-assets/images/billToCompanyBillImageHalfcard-updated.png",
    HALF_CARD_ALT: "Bill Image Required Icon",
};
